import { createModel } from '@rematch/core';
import { Contact } from 'domains/orgDomain';
import {
  PartialResellerCertificate,
  ResellerCertificate,
} from 'domains/resellerCertificateDomain';
import { RootModel } from 'models';
import resellerCertificateService from 'services/resellerCertificateService';
import { baseReducers, BaseState } from './baseReducers';

interface ResellerCertificateState extends BaseState {
  pagedData?: ResellerCertificate[];
  allAccounts?: ResellerCertificate[];
  accountWithLink?: ResellerCertificate;
  size: number;
  email: string;
  page: number;
  curItem?: PartialResellerCertificate;
  roleData: any[];
  token?: string;
  tokenType?: string;
  loginRedirect?: string;
  curContact?: Contact;
}

export const resellerCertificate = createModel<RootModel>()({
  state: {
    size: 20,
    page: 1,
  } as ResellerCertificateState,
  reducers: {
    ...baseReducers<ResellerCertificateState>(),
  },
  effects: (dispatch) => {
    const { resellerCertificate } = dispatch;
    return {
      async getPage(payload, state): Promise<void> {
        const pagedData = await resellerCertificateService.getPaged({
          size: state.resellerCertificate.size,
          page: state.resellerCertificate.page,
        });
        resellerCertificate.setState({
          pagedData: pagedData,
        });
      },

      async updateResellerCertificate(
        payload: PartialResellerCertificate
      ): Promise<void> {
        await resellerCertificateService.updateResellerCertificate(payload);
      },
    };
  },
});
